export default "__VITE_ASSET__umEeo_G$__"